import { Link, useLocation, useNavigate } from 'react-router-dom'
import styles from './styles.module.css'
import { useEffect } from 'react'
import PrimaryButton from '../../global/components/buttons/primary-button/PrimaryButton'
import SecondaryButton from '../../global/components/buttons/secondary-button/SecondaryButton'
import { AUDIT_NAMES, AUDIT_PATHS } from '../../global/constants/audit'

const lastAuditPathKey = 'lastAuditPath'
const BASE_PATH = '/audits'
const PATHS = {
  INSTALLATION: {
    NAME: AUDIT_NAMES.installation,
    PATH: AUDIT_PATHS.installation,
  },
  DVIR: {
    NAME: AUDIT_NAMES.dvir,
    PATH: AUDIT_PATHS.dvir,
  },
  COACHING: {
    NAME: AUDIT_NAMES.coaching,
    PATH: AUDIT_PATHS.coaching,
  },
  VAN_DOWN: {
    NAME: AUDIT_NAMES.vanDown,
    PATH: AUDIT_PATHS.vanDown,
  },
  AI_TRAINING: {
    NAME: AUDIT_NAMES.aiTraining,
    PATH: AUDIT_PATHS.aiTraining,
  },
}
const DEFAULT_PATH = PATHS.INSTALLATION.PATH

function TabChooser() {
  const navigate = useNavigate()

  const links = [
    {
      name: PATHS.INSTALLATION.NAME,
      path: PATHS.INSTALLATION.PATH,
    },
    {
      name: PATHS.DVIR.NAME,
      path: PATHS.DVIR.PATH,
    },
    {
      name: PATHS.COACHING.NAME,
      path: PATHS.COACHING.PATH,
    },
    {
      name: PATHS.VAN_DOWN.NAME,
      path: PATHS.VAN_DOWN.PATH,
    },
    {
      name: PATHS.AI_TRAINING.NAME,
      path: PATHS.AI_TRAINING.PATH,
    },
  ]

  const activePath = useLocation().pathname

  const noActivePath = activePath === BASE_PATH

  useEffect(() => {
    if (noActivePath) {
      const lastQueuePath = localStorage.getItem(lastAuditPathKey)

      navigate(lastQueuePath || DEFAULT_PATH)
    } else {
      const pathToSave =
        links.find((link) => link.path === activePath)?.path || DEFAULT_PATH

      localStorage.setItem(lastAuditPathKey, pathToSave)
    }
  }, [noActivePath, navigate])

  return (
    <div className={styles.buttonsHolder}>
      {links.map((link, idx) =>
        link.path === activePath ? (
          <Link
            className={styles.link}
            to={link.path}
            key={idx}
          >
            <PrimaryButton
              buttonName={link.name}
              onClick={() => {}}
              style={{ width: 'max-content', height: 'max-content' }}
            />
          </Link>
        ) : (
          <Link
            className={styles.link}
            to={link.path}
            key={idx}
          >
            <SecondaryButton
              buttonName={link.name}
              onClick={() => {}}
              style={{ width: 'max-content', height: 'max-content' }}
            />
          </Link>
        ),
      )}
    </div>
  )
}

export default TabChooser
